import { useEffect, useRef } from 'react';

import { useComponentDidMount } from '@shared/hooks/react';
import * as history from '@shared/router/location';
import { useRouterState } from '@shared/router/state';

export function useHistoryRouter(): void {
	const { setCurrentPath, refresh } = useRouterState();

	const setCurrentPathRef = useRef(setCurrentPath);
	const refreshRef = useRef(refresh);

	useEffect(() => {
		setCurrentPathRef.current = setCurrentPath;
		refreshRef.current = refresh;
	});

	useComponentDidMount(() => {
		const onLocationChange = (event: CustomEvent) => {
			const direction = event.detail?.direction;

			if (direction === history.LocationRefreshEvent) {
				refreshRef.current();
			} else {
				setCurrentPathRef.current(
					window.location.pathname + window.location.search,
					event.detail?.transition
				);
			}
		};

		setCurrentPathRef.current(
			window.location.pathname + window.location.search
		);

		window.addEventListener(
			history.LocationChangeEvent,
			onLocationChange as EventListener
		);

		return () => {
			window.removeEventListener(
				history.LocationChangeEvent,
				onLocationChange as EventListener
			);
		};
	});
}
